export default "__VITE_ASSET__BdsiW6_S__"